module.exports = __webpack_public_path__ + "img/升学通路规划@2x (2).a53c9421.png";